import script from "./payDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./payDetails.vue?vue&type=script&setup=true&lang=js"

import "./payDetails.vue?vue&type=style&index=0&id=761023b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-761023b4"]])

export default __exports__